import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
import AboutUs from '@/views/Static/AboutUs'
import FAQ from '@/views/Static/FAQ'
import HelpCenter from '@/views/Static/HelpCenter'
import HowToBook from '@/views/Static/HowToBook'
import HowItWorks from '@/views/Static/HowItWorks'
import BecomeAGuider from '@/views/Static/BecomeAGuider'
import PrivacyAndPolicy from '@/views/Static/PrivacyAndPolicy'
import TermsAndCondition from '@/views/Static/TermsAndCondition'
import TermsAndConditionGuider from '@/views/Static/TermsAndConditionGuider'

import StarX from '@/views/Service/StarX'
import StarGroup from '@/views/Service/StarGroup'
import StarVan from '@/views/Service/StarVan'
import StarRoad from '@/views/Service/StarRoad'
import StarTrip from '@/views/Service/StarTrip'
import StarPick from '@/views/Service/StarPick'

import Login from '@/views/Login'
import Corporate from '@/views/Corporate'
import ResetPassword from '@/views/ResetPassword'

import MyAccount from '@/views/MyAccount'
import ConfirmationEmail from '@/views/ConfirmationEmail'

import Order from '@/views/Order'

import Pay from '@/views/Pay/Pay'
import PayNow from '@/views/Pay/Now'
import PayConfirmation from '@/views/Pay/Confirmation'
import PaySuccess from '@/views/Pay/Success'
import PayPending from '@/views/Pay/Pending'
import PayFailed from '@/views/Pay/Failed'

import Support from '@/views/Support/Support'
import SupportRegisterComplete from '@/views/Support/RegisterComplete'

import Content from '@/views/Content/Content'
// articles
import Article191017 from '@/views/Content/Article191017'
import Article191014 from '@/views/Content/Article191014'
import Article191029 from '@/views/Content/Article191029'
import Article1911261 from '@/views/Content/Article191126-7-keajaiban-dunia'
import Article1911262 from '@/views/Content/Article191126-hotel-penjara-karosta'
import Article1911263 from '@/views/Content/Article191126-the-changing-of-the-guard'
import Article200204 from '@/views/Content/Article200204-destinasi-wisata-keluarga-cemara'
// promos
import Promo200120 from '@/views/Content/Promo200120ChineseNewYear'

import PageNotFound from '@/views/PageNotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },

    /* Static */
    {
      path: '/about-us',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/help-center',
      name: 'HelpCenter',
      component: HelpCenter
    },
    {
      path: '/how-to-book',
      name: 'HowToBook',
      component: HowToBook
    },
    {
      path: '/how-it-works',
      name: 'HowItWorks',
      component: HowItWorks
    },
    {
      path: '/become-a-guider',
      name: 'BecomeAGuider',
      component: BecomeAGuider
    },
    {
      path: '/terms-and-condition',
      name: 'TermsAndCondition',
      component: TermsAndCondition
    },
    {
      path: '/capt-terms-and-condition',
      name: 'TermsAndConditionGuider',
      component: TermsAndConditionGuider
    },
    {
      path: '/privacy-and-policy',
      name: 'PrivacyAndPolicy',
      component: PrivacyAndPolicy
    },
    /* END Static */

    /* Services */
    {
      path: '/services/starx',
      name: 'StarX',
      component: StarX
    },
    {
      path: '/services/stargroup',
      name: 'StarGroup',
      component: StarGroup
    },
    {
      path: '/services/starvan',
      name: 'StarVan',
      component: StarVan
    },
    {
      path: '/services/starroad',
      name: 'StarRoad',
      component: StarRoad
    },
    {
      path: '/services/startrip',
      name: 'StarTrip',
      component: StarTrip
    },
    {
      path: '/services/starpick',
      name: 'StarPick',
      component: StarPick
    },
    /* END Service */

    /* Authentication */
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Login
    },
    {
      path: '/corporate',
      name: 'Corporate',
      component: Corporate
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    /* END Authentication */

    /* User Account */
    {
      path: '/myaccount',
      name: 'MyAccount',
      component: MyAccount
    },
    {
      path: '/confirmation-email',
      name: 'ConfirmationEmail',
      component: ConfirmationEmail,
      props (route) {
        return route.query || {}
      }
    },
    /* END User Account */

    /* Payment */
    {
      path: '/pay',
      name: 'Pay',
      component: Pay,
      children: [
        {
          path: 'now',
          name: 'Pay_Now',
          component: PayNow
        },
        {
          path: 'confirmation',
          name: 'Pay_Confirmation',
          component: PayConfirmation
        },
        {
          path: 'success',
          name: 'Pay_Success',
          component: PaySuccess
        },
        {
          path: 'pending',
          name: 'Pay_Pending',
          component: PayPending
        },
        {
          path: 'failed',
          name: 'Pay_Failed',
          component: PayFailed
        }
      ]
    },
    /* END Payment */

    /* Order */
    {
      path: '/order',
      name: 'Order',
      component: Order
    },
    /* END Order */

    /* Support */
    {
      path: '/sp',
      name: 'Support',
      component: Support,
      children: [
        {
          path: 'register-complete',
          name: 'Support_RegisterComplete',
          component: SupportRegisterComplete
        }
      ]
    },
    {
      path: '/content',
      name: 'Content',
      component: Content,
      children: [
        // articles
        {
          path: 'cara-menghemat-pengeluaran-ketika-berlibur',
          name: 'Content_Article191014',
          component: Article191014
        },
        {
          path: 'tempat-tempat-menyeramkan-di-eropa',
          name: 'Content_Article191017',
          component: Article191017
        },
        {
          path: 'layanan-pemandu-wisata-oleh-mahasiswa-indonesia-di-luar-negeri',
          name: 'Content_Article191029',
          component: Article191029
        },
        {
          path: '7-keajaiban-dunia',
          name: 'Content_Article191126-7-keajaiban-dunia',
          component: Article1911261
        },
        {
          path: 'hotel-penjara-karosta',
          name: 'Content_Article191126-hotel-penjara-karosta',
          component: Article1911262
        },
        {
          path: 'the-changing-of-the-guard',
          name: 'Content_Article191126-the-changing-of-the-guard',
          component: Article1911263
        },
        {
          path: 'destinasi-wisata-keluarga-cemara',
          name: 'Content_Article200204-destinasi-wisata-keluarga-cemara',
          component: Article200204
        },

        // promos
        {
          path: 'kado-spesial-untuk-kamu',
          name: 'Content_Promo200120ChineseNewYear',
          component: Promo200120
        }
      ]
    },
    /* END Support */

    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound
    }
  ],
  scrollBehavior () {
    // reset position to top
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js